import '../canvas-node-tree-panel/interface';
export var NsFlowchartPanelData;
(function (NsFlowchartPanelData) {
    NsFlowchartPanelData.id = 'FLOWCHART_PANEL_DATA';
})(NsFlowchartPanelData || (NsFlowchartPanelData = {}));
//# sourceMappingURL=interface.js.map